import React, { useState, useEffect, useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { imageService, contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

const ensureCdnUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const baseDomain = 'https://cdn.lichviet.org';
  const path = url.startsWith('/') ? url : `/${url}`;
  return baseDomain + path;
};

const STATUS_OPTIONS = [
  { label: 'Hoạt động', value: 1 },
  { label: 'Khóa', value: 0 },
];

const CHANNEL_OPTIONS = [
  { label: 'VPS', value: 'vps' },
  { label: 'S3 Viettel IDC', value: 's3_viettel' },
];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  {
    title: 'ẢNH',
    dataIndex: 'image_url',
    key: 'image_url',
    width: 100,
    render: (u) => u ? <img src={ensureCdnUrl(u)} alt="" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 6 }} /> : '-',
  },
  { title: 'TIÊU ĐỀ', dataIndex: 'title', key: 'title', width: 180, ellipsis: true },
  {
    title: 'NGƯỜI TẠO',
    dataIndex: 'author_name',
    key: 'author_name',
    width: 140,
    render: (val, r) => val || r.create_by || '-',
  },
  {
    title: 'DANH MỤC',
    dataIndex: 'category_name',
    key: 'category_name',
    width: 150,
    render: (val, r) => val ? `[${r.category_id}] ${val}` : (r.category_id || '-'),
  },
  {
    title: 'LINK SOURCE',
    dataIndex: 'image_url',
    key: 'link_source',
    width: 250,
    render: (u) => u ? <Text copyable={{ text: ensureCdnUrl(u) }} className="text-gray-500 text-xs font-mono">{ensureCdnUrl(u)}</Text> : '-',
  },
  {
    title: 'TRẠNG THÁI',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    render: (s) => s === 0 ? <Tag color="red">KHÓA</Tag> : <Tag color="green">HOẠT ĐỘNG</Tag>,
  },
  {
    title: 'NGÀY TẠO',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 140,
    render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-',
  },
];

const QuanLyHinhAnh = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'category_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
  ], [categories]);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tiêu đề', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tiêu đề!' }] },
    { name: 'image_url', label: 'Hình ảnh', type: 'upload-cdn', rules: [{ required: true, message: 'Vui lòng chọn ảnh!' }] },
    // photo.category_id là NOT NULL không default: bỏ trống là HTTP 500 ở DB (QA-01)
    { name: 'category_id', label: 'Danh mục', type: 'select', options: categories, rules: [{ required: true, message: 'Vui lòng chọn danh mục!' }], propsInput: { showSearch: true, allowClear: true, optionFilterProp: 'label' } },
    { name: 'channel', label: 'Kênh lưu trữ', type: 'select', options: CHANNEL_OPTIONS, defaultValue: 'vps' },
    { name: 'description', label: 'Mô tả', type: 'textarea' },
    { name: 'metadata', label: 'Metadata / SEO', type: 'textarea' },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ HÌNH ẢNH"
      subTitle="Quản lý hình ảnh trong hệ thống"
      itemsName="Hình ảnh"
      queryKey="imageList"
      service={imageService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo tiêu đề..."
      addButtonLabel="Thêm ảnh"
    />
  );
};

export default QuanLyHinhAnh;
